import { render } from "./CurateProfile.vue?vue&type=template&id=4a4cbb70&scoped=true"
import script from "./CurateProfile.vue?vue&type=script&lang=js"
export * from "./CurateProfile.vue?vue&type=script&lang=js"

import "./CurateProfile.vue?vue&type=style&index=0&id=4a4cbb70&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4cbb70"]])

export default __exports__